/* Rain or Shine Golf: SOL collection + search facets (Boost replacement).
   Native Shopify filtering via the Section Rendering API, shareable URLs, back/forward,
   mobile drawer with focus trap, Load more with position restore. Vanilla JS, no dependencies.
   Markup contract: sections/sf-ros-sol-collection.liquid, sections/sf-ros-sol-search.liquid,
   snippets/sf-ros-sol-facets.liquid (data-solc-* attributes). */
(function () {
  'use strict';
  if (window.__solcInit) return;
  window.__solcInit = true;

  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var FILTER_ICON = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="16" cy="6" r="2" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="10" cy="12" r="2" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="18" cy="18" r="2" fill="none" stroke="currentColor" stroke-width="2"/></svg>';

  function one(root, sel) { return root.querySelector(sel); }
  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function onMQ(mq, fn) { if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); }
  function modified(e) { return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button && e.button > 0); }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (x) { el.focus(); } }
  function merge(a, b) { var o = {}, k; a = a || {}; for (k in a) o[k] = a[k]; for (k in b) o[k] = b[k]; return o; }

  function Solc(root) {
    this.root = root;
    this.sid = root.getAttribute('data-section-id');
    this.path = location.pathname;
    this.view = new URLSearchParams(location.search).get('view');
    this.cache = {};
    this.cacheKeys = [];
    this.ctrl = null;
    this.timer = 0;
    this.drawer = one(root, '[data-solc-drawer]');
    this.form = one(root, '[data-solc-form]');
    this.sort = one(root, '[data-solc-sort]');
    this.slot = one(root, '[data-solc-sortslot]');
    this.live = one(root, '[data-solc-live]');
    this.sortHome = this.sort ? this.sort.parentNode : null;
    this.bind();
    this.placeSort();
    this.initGuide();
    this.initFab();
    this.restore();
  }
  var P = Solc.prototype;

  P.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!self.form || t.form !== self.form) return;
      if (t.hasAttribute('data-solc-price')) return self.queue(450);
      self.queue(t.type === 'checkbox' ? 120 : 0);
    });
    root.addEventListener('input', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-solc-price')) self.queue(900);
    });
    if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.queue(0); });
    root.addEventListener('click', function (e) {
      var t = e.target, a;
      if (!t || !t.closest) return;
      if ((a = t.closest('[data-solc-link]'))) { if (modified(e)) return; e.preventDefault(); self.go(a.href, true); return; }
      if ((a = t.closest('[data-solc-more]'))) { if (modified(e)) return; e.preventDefault(); self.more(a); return; }
      if ((a = t.closest('[data-solc-open]'))) { e.preventDefault(); self.open(a); return; }
      if ((a = t.closest('[data-solc-close]'))) { e.preventDefault(); self.close(a.hasAttribute('data-solc-done')); return; }
      if ((a = t.closest('[data-solc-showall]'))) { self.toggleAll(a); return; }
      if ((a = t.closest('[data-solc-guide-toggle]'))) { self.toggleGuide(a); return; }
      if (t.closest('[data-solc-grid] a')) self.remember();
    });
    window.addEventListener('popstate', function () {
      if (location.pathname === self.path) self.go(location.href, false);
    });
    onMQ(DESKTOP, function () {
      self.placeSort();
      if (DESKTOP.matches) self.close(false, true);
    });
  };

  /* Sort lives in the toolbar on desktop and at the top of the drawer below 990px. */
  P.placeSort = function () {
    if (!this.sort || !this.slot || !this.sortHome) return;
    var target = DESKTOP.matches ? this.sortHome : this.slot;
    if (this.sort.parentNode !== target) target.appendChild(this.sort);
  };

  P.queue = function (ms) {
    var self = this;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () { self.submit(); }, ms);
  };

  P.submit = function () {
    if (!this.form) return;
    var fd = new FormData(this.form), p = new URLSearchParams();
    fd.forEach(function (v, k) {
      if (typeof v === 'string') v = v.trim();
      if (v === '' || k === 'page') return;
      p.append(k, v);
    });
    var lo = p.get('filter.v.price.gte'), hi = p.get('filter.v.price.lte');
    if (lo && hi && parseFloat(lo) > parseFloat(hi)) { p.set('filter.v.price.gte', hi); p.set('filter.v.price.lte', lo); }
    if (lo !== null && parseFloat(lo) <= 0) p.delete('filter.v.price.gte');
    var ss = this.root.querySelector('[data-solc-sortsel]');
    if (ss && p.get('sort_by') === ss.getAttribute('data-default')) p.delete('sort_by');
    var action = this.form.getAttribute('action') || location.pathname;
    var qs = p.toString();
    this.go(action + (qs ? '?' + qs : ''), true);
  };

  P.normalize = function (url) {
    var u = new URL(url, location.href);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    if (this.view && !u.searchParams.has('view')) u.searchParams.set('view', this.view);
    return u.pathname + u.search;
  };

  P.fetchSection = function (href, useCache) {
    var self = this;
    if (useCache && this.cache[href]) return Promise.resolve(this.cache[href]);
    if (this.ctrl) this.ctrl.abort();
    var ctrl = this.ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var url = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(this.sid);
    return fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (useCache) {
          self.cache[href] = html;
          self.cacheKeys.push(href);
          if (self.cacheKeys.length > 12) delete self.cache[self.cacheKeys.shift()];
        }
        return html;
      });
  };

  P.go = function (url, push) {
    var self = this, href = this.normalize(url);
    clearTimeout(this.timer);
    this.loading(true);
    this.fetchSection(href, true).then(function (html) {
      self.swap(html);
      if (push && href !== location.pathname + location.search) history.pushState({ solc: 1 }, '', href);
      self.loading(false);
      self.after(href);
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      self.loading(false);
      window.location.href = href;
    });
  };

  P.loading = function (on) {
    this.root.classList.toggle('is-loading', on);
    var r = one(this.root, '[data-solc-swap="results"]');
    if (r) r.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  P.swap = function (html) {
    var self = this, root = this.root;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-solc]');
    if (!fresh) throw new Error('section missing');
    var active = document.activeElement;
    var activeId = active && root.contains(active) ? active.id : '';
    var typed = active && active.hasAttribute && active.hasAttribute('data-solc-price') ? active.value : null;
    var openState = {}, expanded = {};
    all(root, '[data-solc-group]').forEach(function (d) {
      var k = d.getAttribute('data-solc-group');
      openState[k] = d.open;
      if (d.querySelector('.solc-opts--long.is-expanded')) expanded[k] = 1;
    });
    var scroller = one(root, '[data-solc-scroll]');
    var st = scroller ? scroller.scrollTop : 0;

    all(fresh, '[data-solc-swap]').forEach(function (n) {
      var cur = root.querySelector('[data-solc-swap="' + n.getAttribute('data-solc-swap') + '"]');
      if (cur) cur.innerHTML = n.innerHTML;
    });
    var fs = fresh.querySelector('[data-solc-sortsel]'), cs = root.querySelector('[data-solc-sortsel]');
    if (fs && cs) cs.value = fs.value;

    all(root, '[data-solc-group]').forEach(function (d) {
      var k = d.getAttribute('data-solc-group');
      if (k in openState) d.open = openState[k];
      if (d.querySelector('.solc-group__n')) d.open = true;
      if (expanded[k]) {
        var ul = d.querySelector('.solc-opts--long'), b = d.querySelector('[data-solc-showall]');
        if (ul) ul.classList.add('is-expanded');
        if (b) self.labelAll(b, true);
      }
    });
    if (scroller) scroller.scrollTop = st;
    if (activeId) {
      var el = document.getElementById(activeId);
      if (el && !el.disabled) {
        focusEl(el);
        /* keep what the shopper is still typing in a price box */
        if (typed !== null && el.value !== typed) { el.value = typed; this.queue(900); }
      }
      else if (this.isOpen()) focusEl(one(this.drawer, '.solc-drawer__x'));
    }
  };

  P.after = function (href) {
    var count = one(this.root, '[data-solc-swap="count"]');
    var txt = count ? count.textContent.trim() : '';
    if (this.live) { this.live.textContent = ''; var lv = this.live; setTimeout(function () { lv.textContent = txt; }, 60); }
    this.updateFab();
    if (!this.isOpen()) this.toResults();
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'sol_filter_apply', sol_url: href, sol_results: parseInt(txt, 10) || 0 });
    } catch (x) {}
  };

  /* The theme header is sticky and reveals on scroll up, so leave room for it. */
  function headerOffset() {
    var h = document.querySelector('sticky-header, .header-group');
    return h ? Math.min(h.getBoundingClientRect().height, 200) : 0;
  }

  P.toResults = function () {
    var tb = one(this.root, '[data-solc-toolbar]');
    if (!tb) return;
    var top = tb.getBoundingClientRect().top, off = headerOffset() + 12;
    if (top < off) window.scrollTo({ top: Math.max(0, window.pageYOffset + top - off), behavior: 'smooth' });
  };

  /* Load more: append the next page, keep real links for crawlers and no-JS. */
  P.more = function (a) {
    if (a.getAttribute('aria-busy') === 'true') return;
    var self = this, href = a.getAttribute('href'), hadFocus = document.activeElement === a;
    var label = a.textContent;
    a.setAttribute('aria-busy', 'true');
    a.textContent = 'Loading';
    this.appendPage(href).then(function (first) {
      var pg = parseInt(new URL(href, location.href).searchParams.get('page'), 10) || 1;
      history.replaceState(merge(history.state, { solc: 1, solcPages: pg }), '');
      if (hadFocus && first) focusEl(first.querySelector('a'));
      if (self.live) self.live.textContent = 'More products loaded';
    }).catch(function () {
      a.removeAttribute('aria-busy');
      a.textContent = label;
      window.location.href = href;
    });
  };

  P.appendPage = function (href) {
    var self = this;
    var url = href + (href.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(this.sid);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = one(self.root, '[data-solc-grid]'), fresh = doc.querySelector('[data-solc-grid]');
        if (!grid || !fresh) throw new Error('grid missing');
        var first = null;
        Array.prototype.slice.call(fresh.children).forEach(function (li) {
          if (li.classList.contains('solc-grid__item--consult')) return;
          grid.appendChild(document.importNode(li, true));
          if (!first) first = grid.lastElementChild;
        });
        var pager = doc.querySelector('[data-solc-swap="pager"]'), cur = one(self.root, '[data-solc-swap="pager"]');
        if (pager && cur) cur.innerHTML = pager.innerHTML;
        return first;
      });
  };

  /* Back from a product page: reload the pages that were open and return to the same spot. */
  P.remember = function () {
    try { history.replaceState(merge(history.state, { solc: 1, solcScroll: window.pageYOffset }), ''); } catch (x) {}
  };

  P.restore = function () {
    var st = history.state, self = this;
    if (!st || !st.solcPages) return;
    var cur = parseInt(new URLSearchParams(location.search).get('page'), 10) || 1;
    if (st.solcPages <= cur) return;
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    var base = new URL(location.href);
    var chain = Promise.resolve();
    for (var n = cur + 1; n <= Math.min(st.solcPages, cur + 10); n++) {
      (function (pg) {
        chain = chain.then(function () {
          base.searchParams.set('page', pg);
          return self.appendPage(base.pathname + base.search);
        });
      })(n);
    }
    chain.then(function () { if (st.solcScroll) window.scrollTo(0, st.solcScroll); }).catch(function () {});
  };

  /* Drawer (below 990px) */
  P.isOpen = function () { return !!(this.drawer && this.drawer.classList.contains('is-open')); };

  P.open = function (btn) {
    if (!this.drawer || DESKTOP.matches || this.isOpen()) return;
    var self = this, d = this.drawer;
    this.lastFocus = btn || document.activeElement;
    this.placeSort();
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    clearTimeout(this.lockT);
    document.documentElement.classList.add('solc-lock');
    d.classList.add('is-open');
    all(this.root, '[data-solc-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    this.keyH = function (e) { self.onKey(e); };
    document.addEventListener('keydown', this.keyH);
    focusEl(one(d, '.solc-drawer__x') || d);
  };

  P.close = function (done, silent) {
    if (!this.isOpen()) return;
    var d = this.drawer;
    d.classList.remove('is-open');
    d.removeAttribute('aria-modal');
    d.removeAttribute('role');
    var self = this;
    clearTimeout(this.lockT);
    this.lockT = setTimeout(function () { if (!self.isOpen()) document.documentElement.classList.remove('solc-lock'); }, 320);
    all(this.root, '[data-solc-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.removeEventListener('keydown', this.keyH);
    if (!silent && this.lastFocus && document.body.contains(this.lastFocus) && this.lastFocus.offsetParent !== null) focusEl(this.lastFocus);
    else if (!silent) focusEl(one(this.root, '[data-solc-open]'));
    if (done) this.toResults();
  };

  P.onKey = function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); this.close(false); return; }
    if (e.key !== 'Tab') return;
    var panel = one(this.drawer, '[data-solc-panel]');
    var f = all(panel, FOCUSABLE).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], cur = document.activeElement;
    if (!panel.contains(cur)) { e.preventDefault(); focusEl(first); }
    else if (e.shiftKey && cur === first) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && cur === last) { e.preventDefault(); focusEl(first); }
  };

  P.labelAll = function (btn, on) {
    if (!btn.getAttribute('data-label')) btn.setAttribute('data-label', btn.textContent);
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    btn.textContent = on ? 'Show fewer' : btn.getAttribute('data-label');
  };

  P.toggleAll = function (btn) {
    var g = btn.closest('[data-solc-group]'), ul = g && g.querySelector('.solc-opts--long');
    if (!ul) return;
    var on = !ul.classList.contains('is-expanded');
    ul.classList.toggle('is-expanded', on);
    this.labelAll(btn, on);
  };

  /* Buying guide clamp */
  P.initGuide = function () {
    var body = one(this.root, '[data-solc-guide]'), btn = one(this.root, '[data-solc-guide-toggle]');
    if (!body || !btn) return;
    if (body.scrollHeight <= body.clientHeight + 48) { body.classList.remove('is-clamped'); btn.hidden = true; }
  };

  P.toggleGuide = function (btn) {
    var body = one(this.root, '[data-solc-guide]');
    if (!body) return;
    var open = btn.getAttribute('aria-expanded') !== 'true';
    body.classList.toggle('is-clamped', !open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? 'Show less' : 'Read the full guide';
    if (!open) {
      var top = body.getBoundingClientRect().top;
      if (top < 0) window.scrollTo({ top: window.pageYOffset + top - headerOffset() - 60 });
    }
  };

  /* Floating "Filter & sort" pill on phones once the toolbar scrolls away. */
  P.initFab = function () {
    if (!this.drawer || !('IntersectionObserver' in window)) return;
    var tb = one(this.root, '[data-solc-toolbar]'), main = one(this.root, '.solc-main');
    if (!tb || !main) return;
    var fab = document.createElement('button');
    fab.type = 'button';
    fab.className = 'solc-fab';
    fab.setAttribute('data-solc-open', '');
    fab.setAttribute('aria-controls', this.drawer.id);
    fab.setAttribute('aria-expanded', 'false');
    fab.innerHTML = FILTER_ICON + '<span>Filter &amp; sort</span><span class="solc-fab__n"></span>';
    this.root.appendChild(fab);
    this.fab = fab;
    this.updateFab();
    var tbOut = false, mainIn = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.target === tb) tbOut = !en.isIntersecting && en.boundingClientRect.top < 0;
        else mainIn = en.isIntersecting;
      });
      fab.classList.toggle('is-shown', tbOut && mainIn);
    });
    io.observe(tb);
    io.observe(main);
  };

  P.updateFab = function () {
    if (!this.fab) return;
    var b = one(this.root, '.solc-toolbar__badge');
    var n = b ? b.textContent.replace(/\D/g, '') : '';
    var slot = this.fab.querySelector('.solc-fab__n');
    slot.textContent = n;
    slot.hidden = !n;
  };

  function init() {
    all(document, '[data-solc]').forEach(function (root) {
      if (root.__solc) return;
      root.__solc = new Solc(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
